import React from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import CustomAvatar from "../Avatar/index";

let id = 0;

function createData(avatar, customer, value) {
    id += 1;
    return { id, avatar, customer, value };
}

const data = [
    createData(<CustomAvatar></CustomAvatar>, "IKEA", "350K"),
    createData(<CustomAvatar></CustomAvatar>, "Volvo", "300K"),
    createData(<CustomAvatar></CustomAvatar>, "Skanska", "280K"),
    createData(<CustomAvatar></CustomAvatar>, "Vattenfall", "270K"),
    createData(<CustomAvatar></CustomAvatar>, "Sandvik", "265K"),
    createData(<CustomAvatar></CustomAvatar>, "Preem", "200K"),
    createData(<CustomAvatar></CustomAvatar>, "Axfood", "190K"),
];

function Tabell() {
    return (
        <div className="table-responsive-material" style={{ width: '95%' }}>
            <Table>
                <TableBody>
                    {data.map(n => {
                        return (
                            <TableRow key={n.id}>
                                <TableCell align="left" style={{ paddingTop: '10px', paddingBottom: '10px', color: 'white' }}>{n.avatar}</TableCell>
                                <TableCell align="center" style={{ paddingTop: '10px', paddingBottom: '10px', color: 'white', fontSize: 22 }}>{n.customer}</TableCell>
                                <TableCell align="right" style={{ paddingTop: '10px', paddingBottom: '10px', color: 'white', fontSize: 22 }}>{n.value}</TableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </div>
    );
}

export default Tabell;